import React from 'react';
import { TimezoneContext, TimezoneSetContext } from './timezone.context';
import { useCurrentuser } from '../current-user-context/current-user.context';
import { SYSTEM_TIMEZONE_IANA } from './local';

export const TimezoneProvider: React.FC<{ initialTimezone?: string }> = ({ children, initialTimezone }) => {
  const [ timezone, setTimezone ] = React.useState(initialTimezone ?? SYSTEM_TIMEZONE_IANA);
  const me = useCurrentuser();

  React.useEffect(() => {
    if (me?.timezone) {
      setTimezone(me.timezone);
    }
  }, [ me?.timezone ]);

  return (
    <TimezoneContext.Provider value={timezone}>
      <TimezoneSetContext.Provider value={setTimezone}>
        {children}
      </TimezoneSetContext.Provider>
    </TimezoneContext.Provider>
  );
};
